import React from 'react';
import AdminDeliveryReport from '../admin/DeliveryReport';

// Super Admin Delivery Report page - reuses the same component as Admin Delivery Report
// The component automatically handles permissions based on user role
const SuperAdminDeliveryReport = () => {
  return <AdminDeliveryReport />;
};

export default SuperAdminDeliveryReport;
